import React, {
  PropsWithChildren,
  useMemo,
} from 'react';
import clsx from 'clsx';
import {
  useFormContext,
} from 'react-hook-form';
import {
  ErrorMessage,
} from '@hookform/error-message';
import keys from 'lodash/keys';
import ToolTip from 'core/components/Tooltip';
import isNil from 'lodash/isNil';
import values from 'lodash/values';
import keyBy from 'lodash/keyBy';

function ErrorMessageList() {
  const { formState: { errors } } = useFormContext();

  const errorsList = useMemo(
    () => keyBy(
      keys(errors).map((key) => (
        isNil(errors[key]?.ref)
          ? values(errors[key])
          : errors[key]
      )).flat(),
      'ref.name',
    ),
    [errors],
  );

  return (
    <div className="flex flex-col gap-1 text-xs">
      <div className="font-semibold">Validation Failed</div>
      <div className="flex flex-col gap-1">
        {keys(errorsList).map((key) => (
          <div key={key} className="w-full">
            <ErrorMessage
              name={key}
              errors={errorsList}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default function DisabledFormTooltip({ children }: PropsWithChildren) {
  const {
    trigger,
    formState: { isValid },
  } = useFormContext();

  return (
    <ToolTip
      title={<ErrorMessageList />}
      hide={isValid}
      disableFocusListener
    >
      <div
        className={clsx('cursor-pointer', { '!cursor-not-allowed': !isValid })}
        onMouseEnter={() => {
          trigger();
        }}
      >
        {children}
      </div>
    </ToolTip>
  );
}
